import React from 'react'
import useSettingsStore, { settingsUpdate } from '../../../../App/Stores/SettingsStore'
import CommonButton from '../../../../Components/Button/CommonButton';
import CommonModal from '../../../../Components/Modal/CommonModal'

const ReferralModal = () => {

    const { setShowReferralModal, showReferralModal, setIs_referral, is_referral } = useSettingsStore();

    return (
        <div>
            <CommonModal
                showModal={showReferralModal}
                setShowModal={setShowReferralModal}
                // widthClass="w-[45vw]"
                modalTitle="confirmation"

                mainContent={
                    <>
                        <div className='my-s20'>Do you want to Deactivate?</div>

                        <div className='flex justify-center'>
                            <CommonButton onClick={() => {
                                const success = settingsUpdate({ type: "is_referral", value: !is_referral });
                                if (success) { setIs_referral(0); setShowReferralModal(false) }
                            }} btnLabel='Deactivate' />
                        </div>
                    </>
                }
            />
        </div>
    )
}

export default ReferralModal